module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"hint":"Bsp: 1234567","label":"Sap Equipment ID"},"fr":{"hint":"Ex.: 1234567","label":"Équipement ID Sap"},"it":{"hint":"Es: 1234567","label":"Sap Equipment ID"}}')
  delete Component.options._Ctor
}
